export default __webpack_public_path__ + "static/media/logoMICROSOFT.6c0e9999.png";